import { StandaloneRow, StandaloneRowProps } from '@/components/Row';
import { useStableOptions } from '@/hooks/useStable';
import { StandaloneComponent } from '@/types/component';

export const Row: StandaloneComponent<StandaloneRowProps> = ({ options, ...props }) => {
  const componentOptions: StandaloneRowProps['options'] = useStableOptions(
    {
      className: 'overflow-x-hidden resize-x w-full p-3 gap-3 mx-auto max-w-content-lg',
      size: 'none',
    },
    options
  );

  if (process.env.OCELOT_SITE === 'residence') {
    return null;
  }

  return <StandaloneRow options={componentOptions} {...props} />;
};
